import {LayoutLogosQuoteBlock} from './LayoutLogosQuoteBlock';
import {LayoutLogosQuoteDivider} from './LayoutLogosQuoteDivider';
import {LayoutLogosTitleLarge} from './LayoutLogosTitleLarge';
import {LayoutLogosTitleSmall} from './LayoutLogosTitleSmall';
import {LayoutLogosWithoutTitle} from './LayoutLogosWithoutTitle';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Logos';

export const LogosQuoteBlock = {
  category,
  displayName: 'Logos Quote Block',
  previewImageURL: prebuiltLayoutPreviewImages.layoutLogosQuoteBlock,
  layout: LayoutLogosQuoteBlock,
};

export const LogosQuoteDivider = {
  category,
  displayName: 'Logos Quote Divider',
  previewImageURL: prebuiltLayoutPreviewImages.layoutLogosQuoteDivider,
  layout: LayoutLogosQuoteDivider,
};

export const LogosTitleLarge = {
  category,
  displayName: 'Logos Title Large',
  previewImageURL: prebuiltLayoutPreviewImages.layoutLogosTitleLarge,
  layout: LayoutLogosTitleLarge,
};

export const LogosTitleSmall = {
  category,
  displayName: 'Logos Title Small',
  previewImageURL: prebuiltLayoutPreviewImages.layoutLogosTitleSmall,
  layout: LayoutLogosTitleSmall,
};

export const LogosWithoutTitle = {
  category,
  displayName: 'Logos Without Title',
  previewImageURL: prebuiltLayoutPreviewImages.layoutLogosWithoutTitle,
  layout: LayoutLogosWithoutTitle,
};
